export interface NavigationItem {
  title: string;
  path: string;
  showInMainNav: boolean;
  subSections?: SubSection[];
}

export interface SubSection {
  title: string;
  anchor: string;
}

export const navigationConfig: NavigationItem[] = [
  {
    title: "Home",
    path: "/",
    showInMainNav: true
  },
  {
    title: "About",
    path: "/about",
    showInMainNav: true
  },
  {
    title: "SORAN Academy",
    path: "/soran-academy",
    showInMainNav: true
  },
  {
    title: "Mpower",
    path: "/mpower",
    showInMainNav: true
  },
  {
    title: "Homeschooling",
    path: "/homeschooling",
    showInMainNav: false
  },
  {
    title: "Workshops",
    path: "/workshops",
    showInMainNav: false
  },
  {
    title: "Pricing",
    path: "/pricing",
    showInMainNav: false
  },
  {
    title: "Contact",
    path: "/contact",
    showInMainNav: true
  },
  {
    title: "Communities",
    path: "/communities",
    showInMainNav: false
  },
  {
    title: "Login",
    path: "/login",
    showInMainNav: false
  },
  {
    title: "Signup",
    path: "/signup",
    showInMainNav: false
  },
  {
    title: "Parent Portal",
    path: "/parent-portal",
    showInMainNav: false
  }
];